import { GridColDef } from "@mui/x-data-grid";
import { BrandLanguage } from "entities/brands/languages/type";
import DropdownList from "shared/components/DropdownList";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";

export const getBrandLanguagesColumns = (
  handleOpenLanguageDetailPage: (language: BrandLanguage) => void,
): GridColDef[] => {
  return [
    {
      field: "displayName",
      headerName: "Language",
      editable: false,
      flex: 1.5,
      sortable: false,
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      editable: false,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => formatUpdatedAt(params.value),
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      editable: false,
      align: "right",
      headerAlign: "right",
      flex: 0.5,
      renderCell: (params) => (
        <DropdownList
          items={[
            {
              title: "Edit",
              onClick: () => {
                handleOpenLanguageDetailPage(params.row);
              },
            },
          ]}
        />
      ),
    },
  ];
};
